import React from 'react'
import {connect} from 'react-redux'

import {getUserMainUniverse} from '../../shared/services/userService.js'
import {loadUniverse} from '../components/UniverseLoader/actions.js'
import Loader from '../../shared/components/Loader/Loader.jsx'

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}

export const CURRENT_USER_PRIORITY = 'currentUser'
export const CURRENT_UNIVERSE_PRIORITY = 'currentUniverse'

export default function withCurrentUniverse(WrappedComponent, priority = CURRENT_UNIVERSE_PRIORITY) {
  class WithCurrentUniverse extends React.Component {
    constructor(props) {
      super(props)
      this.state = {
        currentUniverse: null,
      }
    }

    componentDidMount() {
      const universe = this.getTargetUniverse()
      this.props.loadUniverse(universe)
      this.setState({
        currentUniverse: universe,
      })
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
      const prevUniverseId = Number(prevProps?.currentUniverse?.id ?? null)
      const universeId = Number(this.props?.currentUniverse?.id ?? null)
      const prevQueryUniverseId = Number(prevProps?.queryString?.universe ?? null)
      const queryUniverseId = Number(this.props?.queryString?.universe ?? null)

      if (
        (queryUniverseId && queryUniverseId !== prevQueryUniverseId && queryUniverseId !== universeId) ||
        (!queryUniverseId && universeId && universeId !== prevUniverseId)
      ) {
        const targetUniverse = this.getTargetUniverse()
        this.props.loadUniverse(targetUniverse)
        this.setState({
          currentUniverse: targetUniverse,
        })
      }
    }

    getTargetUniverse = () => {
      if (this.props.queryString && this.props.queryString?.universe) {
        const filteredUniverses = this.props?.universes.filter((universe) => {
          return universe.id === Number(this.props.queryString?.universe)
        })
        if (filteredUniverses.length) {
          return filteredUniverses[0]
        }
      }

      if (priority === CURRENT_UNIVERSE_PRIORITY) {
        if (null !== this.props.currentUniverse) {
          return this.props.currentUniverse
        }
        if (null !== this.props.currentUser) {
          return getUserMainUniverse(this.props.currentUser, this.props?.universes)
        }
      } else {
        if (null !== this.props.currentUser) {
          return getUserMainUniverse(this.props.currentUser, this.props?.universes)
        }
        if (null !== this.props.currentUniverse) {
          return this.props.currentUniverse
        }
      }

      return this.props.universes.length ? this.props?.universes[0] : null
    }

    render() {
      if (null === this.state.currentUniverse) {
        return <Loader visible={true} fill={true}/>
      }

      return <WrappedComponent
        currentUniverse={this.state.currentUniverse}
        {...this.props}
      />
    }
  }
  WithCurrentUniverse.displayName = `WithCurrentUniverse(${getDisplayName(WrappedComponent)})`

  return connect(
    (state) => ({
      currentUniverse: state?.universe.currentUniverse ?? null,
      currentUser: state.currentUser.user,
      universes: state?.universe?.universes,
    }),
    (dispatch) => ({
      loadUniverse: (universe) => dispatch(loadUniverse(universe))
    })
  )(WithCurrentUniverse)
}
